export enum OrganizationFeatures {
  Default = 'Default',
  Groups = 'Groups',
  ServiceCategory = 'ServiceCategory'
}
